import { getClientStream } from '@confluence/ssr-data-streaming/entry-points/client.ts';
import { getServerStream } from '@confluence/ssr-data-streaming/entry-points/server.ts';

// This module acts as a live store for streamed SmartLink SSR batch data.
let storeState: Record<string, any> = {};
let boundaryMap: Record<string, string> = {};

/**
 * Update the shared store with new batch data.
 * On the server, this also automatically emits the data to the client stream.
 */
export const updateSSRSmartLinksStore = (data: Record<string, any>) => {
	Object.assign(storeState, data);

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && window.__SSR_REACT_STREAMING__) {
		const stream = getServerStream('smartlinks');
		if (stream) {
			stream.emit(data);
		}
	}
};

/**
 * Read the latest state from the store.
 */
export const getSSRSmartLinksStore = () => {
	return storeState;
};

/**
 * Update the global boundary map.
 * On the server, this also automatically emits the map to the client stream.
 */
export const updateSSRSmartLinksBoundaryMap = (data: Record<string, string>) => {
	Object.assign(boundaryMap, data);

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && window.__SSR_REACT_STREAMING__) {
		const stream = getServerStream('smartlinks-boundary-map');
		if (stream) {
			stream.emit(data);
		}
	}
};

/**
 * Read the latest boundary map.
 */
export const getSSRSmartLinksBoundaryMap = () => {
	return boundaryMap;
};

/**
 * Reset the store and map.
 */
export const resetSSRSmartLinksStore = () => {
	storeState = {};
	boundaryMap = {};
};

// Initialize stream listeners at the module level for the browser.
// This ensures we catch all stream pulses as they arrive
// regardless of when the first SmartLink component mounts.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
if (!process.env.REACT_SSR) {
	const dataStream = getClientStream('smartlinks');
	dataStream.addListener((batchData: any) => {
		Object.assign(storeState, batchData);
	});

	const boundaryStream = getClientStream('smartlinks-boundary-map');
	boundaryStream.addListener((mapData: any) => {
		Object.assign(boundaryMap, mapData);
	});
}
